import { TypographyElement, Skeleton, Spacing } from 'UI'
import classNames from 'classnames'
import { ExternalAlphormPages } from 'constants/'
import { createUseStyles } from 'react-jss'
import style from './style'
import Text from './text.json'
import { decorateUrl } from 'components/common/UTMscript'

const useStyles = createUseStyles(style)

export default ({ className, loading, IsFrance }) => {
  const { funding, tag, linkClass } = useStyles()
  if (!IsFrance) return null
  return (
    <div className={classNames(funding, className)}>
      {loading
        ? <Skeleton height={30} width='40%' margin={Spacing(3, 0, 0, 0)} />
        : (
          <>
            <TypographyElement
              variant='body2'
              spacing={Spacing(0, 4, 0, 0)}
            >
              {Text.eligible}
            </TypographyElement>
            {[Text.CPF, Text.PE, Text.OPCO].map((item, index) => (
              <a key={index} aria-label='CPF-Link' target='_blank' rel='noopener noreferrer' href={decorateUrl(ExternalAlphormPages.Funding)} className={linkClass}>
                <TypographyElement
                  variant='body2'
                  className={tag}
                  margin={Spacing(0, 2, 0, 0)}
                  spacing={Spacing(2, 3, 2, 3)}
                >
                  {item}
                </TypographyElement>
              </a>
            ))}
          </>)}
    </div>
  )
}
